<template>
  <div class="lr-intent-popup">
    <div class="popup-container">
      <div class="intent-close">
        <button type="button" data-close @click="decline">
          <i class="fal fa-times"></i>
        </button>
      </div>
      <div class="popup-image" :style="'background-image: url(' + image + ')'"></div>
      <div class="popup-message">
        <h2>Please don't go yet!</h2>
        <p>Just your signature will help save my home.</p>
        <button type="button" class="action-btn" data-close @click="confirm">Ok let's do this!</button>
        <button type="button" class="decline-btn" data-close @click="decline">Sorry I can't help</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leaf-relief-intent-popup",

  props: {
    image: {
      type: String,
    },
  },

  mounted() {
    // Override popup overlay color
    this.setOverlayBg("transparent");
  },
  methods: {
    confirm() {
      this.$store.dispatch("logPopupActioned");

      // Revert popup overlay color
      this.setOverlayBg();
    },
    decline() {
      this.$store.dispatch("logPopupDeclined");

      // Revert popup overlay color
      this.setOverlayBg();
    },
    setOverlayBg(color = "") {
      $('.reveal-overlay').css("background-color", color);
    }
  }
};
</script>

<style scoped>
.lr-intent-popup {
  z-index: 101;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: #00000050;
}

.lr-intent-popup button {
  cursor: pointer;
}

.popup-container {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 500px;
  max-width: 765px;
  background: var(--wwfWhite);
  border: solid 10px var(--wwfBlack);
}

.intent-close {
  position: absolute;
  top: 5px;
  right: 10px;
}

.intent-close i {
  font-size: 2rem;
  color: var(--wwfGrey82);
}

.popup-image {
  width: 48%;
  background-position: top center;
  background-size: cover;
}

.popup-message {
  flex: 1;
  margin: auto;
  padding: 2.5rem;
}

.popup-message h2 {
  margin-bottom: 2rem;
  font-size: 3rem;
  line-height: 1;
}

.popup-message p {
  font-size: 2rem;
  font-weight: bold;
  line-height: normal;
}

.action-btn {
  display: block;
  margin: 2rem 0;
  padding: 0.5rem 3rem 0.8rem;
  font-family: "WWFRegular",sans-serif;
  font-size: 2rem;
  color: var(--wwfWhite);
  text-transform: uppercase;
  background: var(--wwfOrange);
  border-radius: 7px;
}

.decline-btn {
  display: block;
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--wwfGrey82);
}
</style>


// WEBPACK FOOTER //
// IntentPopup.vue?1a291904